<script>
</script>
<div>
    <h3><img alt="Gourmet Logo" src="/images/cookie.png"/> Gourmet</h3>
    <p>Welcome to Gourmet Recipe Manager's web edition. We are still in early days, so congratulations on being an early adopter!</p>
    <p>For questions or support inquiries, please email <a href="mailto:support@gourmetrecipemanager.com">support@gourmetrecipemanager.com</a></p>
</div>
<style>
 h3 {
     font-family: var(--brandFont);
     font-size: 2rem;
     margin-top: 2rem;
 }
 h3 img {
     height: 2rem;
 }
 
 
 div {
     max-width: 35em;
     margin: auto;
 }

 p {
     margin-bottom: 1rem;
     line-height: 1.6;
 }
</style>
